import isEmpty from "lodash/isEmpty";
import validateTimeRange from "views/components/TimeRangeValidation";
import { validatePluggableValues } from "views/logic/searchbar/pluggableSearchBarControlsHandler";
const validate = async (values, limitDuration, setFieldWarning, validateQueryString, pluggableSearchBarControls, formatTime, context, userTimezone) => {
  const { timerange: nextTimeRange } = values;
  let errors = {};
  const timeRangeErrors = await validateTimeRange(nextTimeRange, limitDuration, formatTime, userTimezone, false);
  if (!isEmpty(timeRangeErrors)) {
    errors = { ...errors, timerange: timeRangeErrors };
  }
  const pluggableSearchBarControlsErrors = validatePluggableValues(values, context, pluggableSearchBarControls);
  if (!isEmpty(pluggableSearchBarControlsErrors)) {
    errors = { ...errors, ...pluggableSearchBarControlsErrors };
  }
  const queryValidation = await validateQueryString(values);
  if ((queryValidation == null ? void 0 : queryValidation.status) === "OK") {
    setFieldWarning("queryString", void 0);
    return errors;
  }
  if ((queryValidation == null ? void 0 : queryValidation.status) === "WARNING" || (queryValidation == null ? void 0 : queryValidation.status) === "INFO") {
    setFieldWarning("queryString", queryValidation);
    return errors;
  }
  if ((queryValidation == null ? void 0 : queryValidation.status) === "ERROR") {
    setFieldWarning("queryString", void 0);
    return { ...errors, queryString: queryValidation };
  }
  return errors;
};
export default validate;
